import { Languages } from '@account/enums/languages.enum';
import { Model } from '@models/core/base.model';

export class CompanyAdminContact extends Model {
    protected static _resource = 'payroll/companies/:company/companyAdminContacts';

    protected static _version = 'v2';

    protected static _serializeAttributes = [
        'firstName',
        'lastName',
        'email',
        'phone',
        'extension',
        'isPrimaryContact',
        'receivePayrollReminders',
        'locale',
    ];

    constructor(res?: object | object[]) {
        super(res);
        this._attributes['locale'] = Languages.ENGLISH;
    }

    // Getters
    get firstName(): string {
        return this._attributes['firstName'];
    }

    get lastName(): string {
        return this._attributes['lastName'];
    }

    get email(): string {
        return this._attributes['email'];
    }

    get phone(): string {
        return this._attributes['phone'];
    }

    get extension(): string {
        return this._attributes['extension'];
    }

    get isPrimaryContact(): boolean {
        return this._attributes['isPrimaryContact'];
    }

    get receivePayrollReminders(): boolean {
        return this._attributes['receivePayrollReminders'];
    }

    get locale(): 'en_CA' | 'fr_CA' {
        return this._attributes['locale'];
    }

    // Setters
    set firstName(value: string) {
        this._attributes['firstName'] = value;
    }

    set lastName(value: string) {
        this._attributes['lastName'] = value;
    }

    set email(value: string) {
        this._attributes['email'] = value;
    }

    set phone(value: string) {
        this._attributes['phone'] = value;
    }

    set extension(value: string) {
        this._attributes['extension'] = value;
    }

    set isPrimaryContact(value: boolean) {
        this._attributes['isPrimaryContact'] = value;
    }

    set receivePayrollReminders(value: boolean) {
        this._attributes['receivePayrollReminders'] = value;
    }

    set locale(value: 'en_CA' | 'fr_CA') {
        this._attributes['locale'] = value;
    }
}
